<template>
  <div class="pages" v-loading="listLoading">
    <div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
      <Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
      <Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
      <Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
      <Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
      <Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
      <Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
      <File v-if='item.Property.Control=="File"' :data-val="item"></File>
      <Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
      <Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
      <Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
      <Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
    </div>


    <Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large"
            type="primary"> 提交
    </Button>
  </div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from "../components/Number.vue";
import Contact from "../components/Contact.vue";
import Version from "../components/Text.vue";
import Money from "../components/Money.vue";
import Tips from "../components/Tips.vue";
import File from "../components/File.vue";
import Dates from '../components/Date.vue';
import Table from "../components/Table.vue";
import Selector from "../components/Selector.vue";
import Textarea from "../components/Textarea.vue";
import Choose from "../components/Choose.vue";
import wx from "weixin-js-sdk";
import stringUtils from "../assets/js/stringUtil.js";
import { initWxConfig } from "../api/jssdk.js";
import { getTemplateInfo, submitProcess } from "@/api/approval";
import {getAgentInfo, getRelation, getUserInfo ,IsFirstInCompany} from "@/api/employee"
import { getDepartmentInfo ,getDepartmentRelationByName } from "@/api/department";
import { CheckApplied,SaveApplied } from '@/api/applied'

var isSubmit = false;

var template = {
  TemplateContent: {
    Controls: [],
  },
};
export default {
  components: {
    Contact,
    Version,
    Money,
    Tips,
    File,
    Table,
    Digit,
    Selector,
    Textarea,
    Choose,
    Dates
  },
  data() {
    return {
      templateData: template,
      relationList: null,
      logInfo: null,
      templateId: "",
      spNo: null,
      formLoading: false,
      listLoading: false,
      isDisabled: false,
    };
  },
  created() {
    this.logInfo = this.getLoginUserInfo();
    initWxConfig(this);
    this.templateId = this.$route.query.templateId;
    this.spNo = this.$route.query.spNo;
    this.getTemplate();
    stringUtils.setAddIsShow(false);
  },
  methods: {
    clickChoose: async function (dataVal, name) {
      var that = this;
      window.wx.invoke(
          "selectEnterpriseContact",
          {
            fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
            mode: "multi", // 必填，选择模式，single表示单选，multi表示多选
            type: ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
            selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
            selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          },
          async function (res) {
            if (res.err_msg === "selectEnterpriseContact:ok") {
              if (typeof res.result == "string") {
                res.result = JSON.parse(res.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
              }
              // 已选的部门列表
              var users = res.result.userList;
              var resultStr = '';
              dataVal.Values = [];
              users.forEach((user,index) => {
                if (index === users.length - 1){
                  resultStr += `${user.name}`
                }else{
                  resultStr += `${user.name},`
                }
                dataVal.Values.push([user.id, user.name]);
              })
              dataVal.Value = resultStr;
            }
          }
      );
    },
    tableOperation (val, type, datas) {
      if (type === "水电物业费用缴纳" || type === "押金意见"){
        this.templateData.TemplateContent.Controls.forEach(col => {
          if (col.Property.Title[0].Text === "新入住宿舍物品发放明细"){
            let showStr = null;
            let children = col.Config.Table.Children;
            children.forEach(child => {
              if (child.Property.Title[0].Text === type){
                let options = child.Config.Selector.Options;
                options.forEach(option => {
                  if (option.Key === val){
                    showStr = option.Value[0].Text;
                  }
                })
              }
              if (type === "水电物业费用缴纳"){
                if (child.Property.Title[0].Text === "未结清原因"){
                  child.IsShow = showStr.indexOf("未结清") > -1;
                }
              }
              if (type === "押金意见"){
                if (child.Property.Title[0].Text === "扣款原因"){
                  child.IsShow = showStr.indexOf("有扣款") > -1;
                }
              }
            })
          }
        })
      }else {
        this.tableoperation(val, type, datas, this);
      }

    },
    getEmployeeRelation: async function() {
      await getRelation(this.logInfo.EmpNo).then( response => {
        this.relationList =  response.Body[0].Nodes;
      });
    },
    getSelectorVal(val, name) {
    },
    getTextVal() {},
    getTemplate: async function () {
      var that = this;
      await that.getEmployeeRelation();
      that.listLoading = true;
      const departName = that.logInfo.fullName;
      const jobLevel = that.logInfo.JobLevel;
      const empName = that.logInfo.EmpName;
      const positionName = that.logInfo.PositionName;
      await CheckApplied(that.logInfo.EmpNo).then(res => {
        if (res.Body === true){
          setTimeout(()=>{
            this.Message({
              message: '你已提交入住申请，不能重复提交。',
              type: 'error',
              duration: 2000
            });
            this.isDisabled=true;
          },200)
        }
      })
      if(departName.indexOf("营业部/住宅部") === -1 || jobLevel > 3){
        setTimeout(()=>{
          this.Message({
            message: '没有申请权限(只有住宅部且职级为1-3级可申请)',
            type: 'error',
            duration: 2000
          });
          this.isDisabled=true;
        },200)
      }
      getTemplateInfo(this.templateId).then(async (response) => {
        var controls = response.Body;
        var that = this;
        let executiveDirector = [];
        for (let i = 0; i < controls.TemplateContent.Controls.length; i++){
          let item = controls.TemplateContent.Controls[i];
          if (item.Property.Title[0].Text === "申请人") {
            item.Value = empName;
            item.Disable = true;
          }
          if (item.Property.Title[0].Text === "所属店董"){
            let shopManager = await that.getRelationList(that.relationList,5);
            if (shopManager.length > 0){
              item.Value = shopManager[0][1]
            }else{
              item.Value = "无"
            }
            item.Disable = true;
          }
          if (item.Property.Title[0].Text === "所属战区"){
            let paths = departName.split("/");
            paths.forEach(path => {
              if (path.indexOf("战区") > -1){
                item.Value = path;
                item.Disable = true;
              }
            })
          }
          if (item.Property.Title[0].Text === "所属大战区"){
            let paths = departName.split("/");
            paths.forEach(path => {
              if (path.indexOf("区") > -1 && path.length === 2){
                item.Value = path;
                item.Disable = true;
              }
            })
          }

          if (item.Property.Title[0].Text === "逐级审批使用"){
            console.log(that.relationList)
            item.Values = await that.getRelationList(that.relationList,7);
            console.log(item.Values)
            if (item.Values == null || item.Values.length < 1) {
              item.Values.push(this.$store.state.defaultMember);
            } else {
              let datas = item.Values;
              //获取逐级审批最后一个的工号
              let endEmpNo = datas[datas.length - 1][0];
              await getAgentInfo(endEmpNo).then((res) => {
                if (res.Body.PositionName.indexOf("店董") > -1) {
                  item.Values.push(this.$store.state.defaultMember);
                }
              });
            }
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "出生年月"){
            item.Property.Control = "Date";
          }
          if (item.Property.Title[0].Text === "宿舍管理员"){
            item.Values = [];
            getDepartmentRelationByName(departName,false).then(res => {
              let nodes = res.Body[0].Nodes;
              nodes.forEach(node => {
                let items = node.Items;
                if (items !== null){
                  items.forEach(nItem => {
                    if (nItem.PositionName.indexOf("行政主任") > -1){
                      console.log(nItem);
                      executiveDirector.push([nItem.EmpNo,nItem.EmpName])
                    }
                  })
                }
              })
            })
          }
          if (item.Property.Title[0].Text === "行政主任"){
            item.Values = []
            item.Values = executiveDirector;
            item.IsShow = false;
          }
          if (item.Property.Title[0].Text === "抄送控件"){
            item.Values = [];
            item.IsShow = false;
            item.Values = executiveDirector;
          }
        }
        this.templateData = this.assignControl(controls, that.logInfo);
        this.listLoading = false;
      });
    },
    submit: async function () {
      //数据校验
      if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
        return;
      }
      this.templateData.TemplateContent.Controls.forEach(item => {
        if (item.Property.Title[0].Text === "出生年月"){
          item.Property.Control = "Text";
        }
      })
      this.isDisabled=true;
      var SummaryList = [];
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];

      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请人："+" "+ this.logInfo.EmpName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请部门："+" "+ this.logInfo.DeptName ,"Lang":"zh_CN"});
      SummaryList.push(info);
      var info={SummaryInfo:[]}
      var data = new Date();
      var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
      var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
      var dateTime = data.getFullYear() + "-" + month + "-" + date;
      info.SummaryInfo=[];
      info.SummaryInfo.push({"Text":"申请时间："+" "+ dateTime ,"Lang":"zh_CN"});
      SummaryList.push(info);
      this.templateData.SummaryList = SummaryList
      //提交
      submitProcess(
          this.templateId,
          this.logInfo.EmpNo,
          this.spNo,
          this.templateData
      )
          .then((response) => {
            //保存
            SaveApplied(this.logInfo.EmpNo,this.logInfo.EmpName);
            this.Message({
              message: "申请成功",
              type: "success",
              duration: 3 * 1000,
            });
            setTimeout(() => {
              this.$router.push("/index");
            }, 3000);
          })
          .catch(err => {
            this.isDisabled=false;
          })
          .finally(() => {
            isSubmit = false;
            this.listLoading = false;
          });
    },
  },
};
</script>

<style scoped>

</style>